import { useState, useMemo, useCallback } from 'react';
import isMapFn from 'lodash.ismap';

export const useItemsToShow = (items, count) => {
  const [isShow, toggle] = useState(false);

  const memoizedToggle = useCallback(
    show => toggle(typeof show === 'boolean' ? show : !isShow),
    [isShow, toggle]
  );

  const itemsToShow = useMemo(() => {
    if (isShow) {
      return items;
    }

    const isMap = isMapFn(items);
    const isArray = Array.isArray(items);
    const isObject = typeof items === 'object' && items !== 'null' && !isArray;

    if (!isArray && !isObject && !isMap) {
      throw new Error(
        'Incorrect type for first argument. should be object or array or Map.'
      );
    }

    if (isMap) {
      return new Map(Array.from(items.entries()).slice(0, count));
    }

    if (isArray) {
      return items.slice(0, count);
    }

    if (isObject) {
      return Object.keys(items)
        .slice(0, count)
        .reduce((result, id) => ({ ...result, [id]: items[id] }), {});
    }

    return items;
  }, [items, isShow, count]);

  return { isShow, toggle: memoizedToggle, items: itemsToShow };
};

export default useItemsToShow;
